"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _amenityCoveredParking = _interopRequireDefault(require("@spothero/icons/amenity-covered-parking"));

var _amenityImmediateParking = _interopRequireDefault(require("@spothero/icons/amenity-immediate-parking"));

var _amenityInOut = _interopRequireDefault(require("@spothero/icons/amenity-in-out"));

var _amenityNoContract = _interopRequireDefault(require("@spothero/icons/amenity-no-contract"));

var _amenityOneTap = _interopRequireDefault(require("@spothero/icons/amenity-one-tap"));

var _amenitySelfPark = _interopRequireDefault(require("@spothero/icons/amenity-self-park"));

var _amenityWheelchair = _interopRequireDefault(require("@spothero/icons/amenity-wheelchair"));

/**
 * Utilities for working with SpotHero amenities.
 * @module AmenityUtils
 */
var AmenityUtils = {
  /**
   * @namespace
   * @typedef {Object} ICONS - An Object of Amenity icons where key names are the Amenity slug
   * @property {Component} attendant - Icon specific to the name.
   * @property {Component} covered - Icon specific to the name.
   * @property {Component} covered-parking - Icon specific to the name.
   * @property {Component} ev - Icon specific to the name.
   * @property {Component} immediate_parking - Icon specific to the name.
   * @property {Component} immediate-parking - Icon specific to the name.
   * @property {Component} in_out - Icon specific to the name.
   * @property {Component} in-out - Icon specific to the name.
   * @property {Component} no_contract - Icon specific to the name.
   * @property {Component} no-contract - Icon specific to the name.
   * @property {Component} one_tap - Icon specific to the name, identical to "mobile" icon.
   * @property {Component} one-tap - Icon specific to the name, identical to "mobile" icon.
   * @property {Component} paved - Icon specific to the name.
   * @property {Component} self_park - Icon specific to the name.
   * @property {Component} self-park - Icon specific to the name.
   * @property {Component} shuttle - Icon specific to the name.
   * @property {Component} touchless - Icon specific to the name.
   * @property {Component} valet - Icon specific to the name.
   * @property {Component} wheelchair - Icon specific to the name.
   * @property {Component} wheelchair_accessible - Icon specific to the name.
   */
  ICONS: {
    // imports that are used in multiple icons are defined up top temporarily until v1 icons are removed
    // imports with require statements below are the de-facto to avoid unnecessary additional variable creation

    /* eslint-disable camelcase */
    attendant: require('@spothero/icons/amenity-attendant').default,
    // search v2 API version
    covered: _amenityCoveredParking.default,
    // search v1 API version
    'covered-parking': _amenityCoveredParking.default,
    ev: require('@spothero/icons/amenity-ev').default,
    // search v2 API version
    immediate_parking: _amenityImmediateParking.default,
    // search v1 API version
    'immediate-parking': _amenityImmediateParking.default,
    // search v2 API version
    in_out: _amenityInOut.default,
    // search v1 API version
    'in-out': _amenityInOut.default,
    // search v2 API version
    no_contract: _amenityNoContract.default,
    // search v1 API version
    'no-contract': _amenityNoContract.default,
    // search v2 API version
    one_tap: _amenityOneTap.default,
    // search v1 API version
    'one-tap': _amenityOneTap.default,
    paved: require('@spothero/icons/amenity-paved').default,
    // search v2 API version
    self_park: _amenitySelfPark.default,
    // search v1 API version
    'self-park': _amenitySelfPark.default,
    shuttle: require('@spothero/icons/amenity-shuttle').default,
    touchless: require('@spothero/icons/amenity-touchless').default,
    valet: require('@spothero/icons/amenity-valet').default,
    wheelchair: _amenityWheelchair.default,
    wheelchair_accessible: _amenityWheelchair.default
    /* eslint-enable camelcase */

  },

  /**
   * Retrieves an amenity icon by its name. Usage requires checking for null and if available, wrapping in JSX brackets.
   * @static
   * @function getIcon
   * @param {String} name - The name of the icon to retrieve.
   * @example
   * const Icon = AmenityUtils.getIcon('ev');
   * {Icon && <Icon className="Foo" />}
   * @returns {ReactElement} - The corresponding amenity React SVG icon component from @spothero/icons.
   */
  getIcon: function getIcon(name) {
    var icon = AmenityUtils.ICONS[name];

    if (!icon) {
      // eslint-disable-next-line no-console
      console.warn("There is no amenity icon available with the name '".concat(name, "'. Add it in fe-utils' AmenityUtils to use it."));
      return null;
    }

    return icon;
  }
};
var _default = AmenityUtils;
exports.default = _default;